<template>
  <ion-page>
    <ion-content>
      <partials-steps steps="5" active="3" :headline="$t('woodBasedPanel.gypsumBoards.headline')"></partials-steps>
      <ion-grid>
        <ion-row>
          <ion-col>
            {{ $t('woodBasedPanel.gypsumBoards.select.title')}}:
          </ion-col>
        </ion-row>

        <ion-row v-for="value in values" :key="value.id">
          <ion-col>
            <label :for="value.replace(/\s+/g, '')" class="btn-clickable">
              <ion-col>
                {{ translationMapping[value] ?? value}}
              </ion-col>
              <input :id="value.replace(/\s+/g, '')" v-model="plattenunterart" @click="changePage()" type="radio" :value="value">
            </label>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="btn-back" size="4" mode="ios">
            <ion-button @click="goBack()">{{ $t('general.back') }}</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonGrid,
  IonRow,
  IonCol
} from '@ionic/vue';
import {defineComponent} from 'vue';
import {store} from "@/store/formtemplate";
import {holzhws} from "@/store/holzhws";
import partialsSteps from "@/views/partials/steps";

export default defineComponent({
  name: 'Gipswerkstoffplatten',
  components: {
    IonContent,
    IonPage,
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    partialsSteps
  },
  computed: {
    plattenunterart: {
      get() {
        return store.getters.getByProperty("plattenunterart")
      },
      set(value) {
        store.commit("set", {property: 'plattenunterart', value: value});
      }
    },
    values: {
      get() {
        const filtered = holzhws.getters.getFilterd;

        return [...new Set(filtered.map(item => item.plattenunterart))];
      }
    },
    translationMapping: {
      get() {
        const filtered = holzhws.getters.getFilterd;
        const filteredData = [];

        filtered.forEach((obj) => {
          filteredData[obj.plattenunterart] = obj.plattenunterart_translated;
        });

        return filteredData;
      }
    }
  },
  methods: {
    changePage: function () {
      this.$router.push("/Holzwerkstoffplatte/Plattendicke");
    },

    goBack: function () {
      store.commit("set", {property: 'plattenunterart', value: ""});
      store.commit("set", {property: 'plattenart', value: ""});

      this.$router.back();
    }
  }
});
</script>
